module.exports = __webpack_public_path__ + "img/about-icons-expertise-web.4a2bdc2f.svg";